export const GET_USER_EMAIL_REQUEST = 'GET_USER_EMAIL_REQUEST';
export const GET_USER_EMAIL_SUCCESS = 'GET_USER_EMAIL_SUCCESS';
export const GET_USER_EMAIL_FAILURE = 'GET_USER_EMAIL_FAILURE';

export const CHANGE_USER_EMAIL_REQUEST = 'CHANGE_USER_EMAIL_REQUEST';
export const CHANGE_USER_EMAIL_SUCCESS = 'CHANGE_USER_EMAIL_SUCCESS';
export const CHANGE_USER_EMAIL_FAILURE = 'CHANGE_USER_EMAIL_FAILURE';

export const CREATE_USER_EMAIL_REQUEST = 'CREATE_USER_EMAIL_REQUEST';
export const CREATE_USER_EMAIL_SUCCESS = 'CREATE_USER_EMAIL_SUCCESS';
export const CREATE_USER_EMAIL_FAILURE = 'CREATE_USER_EMAIL_FAILURE';

export const REMOVE_USER_EMAIL_REQUEST = 'REMOVE_USER_EMAIL_REQUEST';
export const REMOVE_USER_EMAIL_SUCCESS = 'REMOVE_USER_EMAIL_SUCCESS';
export const REMOVE_USER_EMAIL_FAILURE = 'REMOVE_USER_EMAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/user_emails.constants.js